<template>
    <el-image fit="contain" :src="imgSrc"></el-image>
</template>

<script>
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import {
        getProDetail,
    } from "@/api/product/detail";
    export default {
        name: "auctionbf",
        data(){
            return{
                imgSrc:''
            }
        },
        asyncData({
                      store,
                      route
                  }) {
            let params = {
                artCode: route.query.picid,
                only_meta: 1
            }
            return store.dispatch("pageProDetail/getProDetail", [params, null, () => {}]);
        },
        computed:{
            ...mapGetters({
                getIsLoadIng: "pageProDetail/getIsLoadIng",
                getData: "pageProDetail/getData",
            }),
        },
        mounted() {
            let parmas = {
                artCode: this.$route.query.picid,
            }
            if (!this.getIsLoadIng) {
                this.getProDetail([parmas, null, () => {
                    this.filteData();
                }])
            } else {
                this.filteData();
            }
        },
        methods:{
            filteData() {
                let data = this.$store.state["pageProDetail"]["data"],
                    that = this;
                console.log(data)
                this.imgSrc = `https://thumb.artron.net/Img/image?src=${data.detail.PicUrl[0]}&w=${this.$route.query.w}`
            },
            getProDetail() {
                let param = {
                    artCode: this.$route.query.picid
                }
                getProDetail(param).then((res) => {
                    this.isLoading = false
                    let dataJSON = res.data,
                        that = this;
                    console.log(dataJSON,'dataJSON')
                    this.imgSrc = `https://thumb.artron.net/Img/image?src=${dataJSON.detail.PicUrl[0]}&w=${this.$route.query.w}`
                });
            },
        }
    }
</script>

<style scoped>

</style>